module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/linescape-journal-of-commerce-technology/linescape-journal-of-commerce-technology.scss
// module id = 873
// module chunks = 0